import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { LunchMenu } from "../../../api/lunchMenus";
import { CatalogScopeContext } from "../../../hooks/useMenu";
import { OrderingShell } from "../components/OrderingShell";
import { LunchMenuList } from "./list/LunchMenuList";
import { LunchMenuEditor } from "./editor/LunchMenuEditor";
import {
  lunchDraftFromMenu,
  newLunchDraft,
  type LunchDraft,
} from "./lunchDraft";

/**
 * „Обедно меню" в „Маркиране" (/ordering/lunch-menu, право manage_lunch_menu):
 * списък с обедните менюта на заведението и редактор, сглобен от каталога на
 * маркирането. Каталогът тук е само основното меню (обхват "regular") —
 * обедните копия се виждат в самото маркиране. Esc от списъка връща при масите
 * (ESC_PARENT_PAGES), от редактора — към списъка.
 */
export default function LunchMenuPage() {
  return (
    <CatalogScopeContext.Provider value="regular">
      <OrderingShell>
        <LunchMenuScreens />
      </OrderingShell>
    </CatalogScopeContext.Provider>
  );
}

interface EditingState {
  menuId: number | null;
  draft: LunchDraft;
}

function LunchMenuScreens() {
  const { t } = useTranslation();
  const [editing, setEditing] = useState<EditingState | null>(null);
  const [selectedMenuId, setSelectedMenuId] = useState<number | null>(null);

  if (editing)
    return (
      <LunchMenuEditor
        menuId={editing.menuId}
        initialDraft={editing.draft}
        onClose={(savedMenuId) => {
          setEditing(null);
          if (savedMenuId != null) setSelectedMenuId(savedMenuId);
        }}
      />
    );

  return (
    <LunchMenuList
      selectedMenuId={selectedMenuId}
      onSelect={setSelectedMenuId}
      onNew={() => setEditing({ menuId: null, draft: newLunchDraft(t) })}
      onEdit={(menu: LunchMenu) =>
        setEditing({ menuId: menu.id, draft: lunchDraftFromMenu(t, menu, false) })
      }
      onCopy={(menu: LunchMenu) =>
        setEditing({ menuId: null, draft: lunchDraftFromMenu(t, menu, true) })
      }
    />
  );
}
